/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import ErrorBoundaryWithTagging from 'bundles/common/components/ErrorBoundaryWithTagging';

export type Props = React.HTMLProps<HTMLButtonElement>;

const styles = {
  link: css`
    background: transparent;
    border: none;
    color: var(--cds-color-interactive-primary);
    cursor: pointer;
    display: inline;
    font-size: inherit;
    padding: 0;
    transition: color 250ms ease-out;
    text-decoration: underline;
  `,
};

const LinkButton = ({ className, ...props }: Props) => (
  <button {...props} css={styles.link} className={className} type="button" />
);

const LinkButtonWithErrorBoundary = (props: Props) => (
  <ErrorBoundaryWithTagging componentName="authentication-common/LinkButton">
    <LinkButton {...props} />
  </ErrorBoundaryWithTagging>
);

export default LinkButtonWithErrorBoundary;
